import {errorToastNotification, warningToastNotification} from "./toastNotificationHelper";

export interface validationType {
  errorMessage?: string,
  warningMessage?: string
}

export const validateWithNotifications = (
  validation: validationType
) => {
  let dispatchedAction;
  const {
    errorMessage,
    warningMessage
  } = validation;

  if (!errorMessage) {
    if (warningMessage) {
      warningToastNotification(warningMessage, {hideAfter: 10});
    }
    dispatchedAction = Promise.resolve();
  } else {
    errorToastNotification(errorMessage, {hideAfter: 10});
    dispatchedAction = Promise.reject(errorMessage);
  }

  return dispatchedAction;
};
